import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import {Theme} from '@mui/styles';
import {PredefinedField} from '~common/lib/types';
import {TextFieldProps} from '@mui/material/TextField';
import RendererRegistry from '~common/lib/renderers'


const styles = (theme: Theme): StyleRules => ({
  suggestion: {
    color: 'blue'
  },
  formField: {
    width: '100%'
  }
});

// BEFORE YOU ADD PROPS HERE:  Please consider that this is a HELPER to use when building forms where the Primary considerations are the contents of the form definition
// Please consider whther adding a property here is really necessary, or wether it belongs as part of the form definition, itself, or whether you should really be using
// one of the underlying controls directly.
interface Props {
  data: any | undefined;
  fieldDefinition?: PredefinedField;
}

type State = {
  value?: any;
};

class PortalUserSuggestionRenderer extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
  }

  static register = () => {
    if (!RendererRegistry.find('PortalUserSuggestionRenderer')) {
      RendererRegistry.register(
        'PortalUserSuggestionRenderer',
        PortalUserSuggestionRenderer
      );
    }
  }

  render() {
    const {data} = this.props;
    console.log("suggestion props", this.props)
    //const { classes }: { classes: ClassNameMap; } = this.props;
    return (
      <div style={{minWidth:300, fontSize: "0.8rem", display: "flex", flexDirection:"column"}}>
        <div style={{fontWeight: 500, marginBottom: 3 }}>{data.label} ({data.value.userName})</div>
      </div>
    );

  }
}

export default withStyles(styles)(PortalUserSuggestionRenderer);

